<template>
  <!-- team member  -->
  <div
    class="space-y-4 sm:grid sm:grid-cols-3 sm:items-start sm:gap-6 sm:space-y-0"
  >
    <div class="aspect-w-3 aspect-h-2 sm:aspect-w-3 sm:aspect-h-4">
      <img
        class="object-cover shadow-lg rounded-lg"
        :src="avatar"
        :alt="name"
      />
    </div>
    <div class="sm:col-span-2">
      <div class="space-y-4">
        <div class="text-lg leading-6 font-medium space-y-1 text-purple">
          <h3 class="text-2xl">{{ name }}</h3>
          <p class="text-purple-light">{{ title }}</p>
        </div>
        <p class="text-sm">
          <slot></slot>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    avatar: String,
    name: String,
    title: String,
  },
};
</script>